import Slider from "../Slider/Slider";

type Props = {
    onChange: (value: number) => void;
};

const ImageZoomSlider = ({ onChange }: Props) => {
    return (
        <>
            <div className='row justify-content-center align-items-center mt-3'>
                <div className='col-auto'>
                    <i className="fa-solid fa-image"></i>
                </div>
                <div className='col'>
                    <Slider
                        onChange={onChange}
                        min={1}
                        max={3}
                    />
                </div>
                <div className='col-auto'>
                    <i className="fa-solid fa-image fa-2xl"></i>
                </div>
            </div>
        </>
    );
};

export default ImageZoomSlider;
